// What the maps API needs to fetch the shapes of a saved area's ids: the area type and its country.
// Pure: no React, router or services.
import { areaCountry, inferLegacyAreaType } from '../config/countries';
import type { CountryCode, MapType } from '../config/countries';
import { isCatalogueArea } from '../config/catalogue';

export interface LookupArea {
  type: string;
  ids?: string[];
  country_code?: string | null;
}

/**
 * Some older saves carry the wrong area type; the country's rule in the registry reads the right one
 * off the first id.
 */
export function correctAreaType(area: LookupArea): string {
  // Catalogue areas were saved with the type their maps gave them.
  if (isCatalogueArea(area)) return area.type;
  const country = areaCountry(area);
  const sampleId = area.ids?.[0];
  return country && typeof sampleId === 'string' ? inferLegacyAreaType(country, sampleId) ?? area.type : area.type;
}

/**
 * The type and country to ask /maps/by-ids with, and whether to ask the catalogue 1.0 maps; null when the
 * country cannot be told.
 */
export function areaLookup(area: LookupArea): { type: MapType; country: CountryCode; catalogue: boolean } | null {
  const country = areaCountry(area);
  if (!country) return null;
  return { type: correctAreaType(area) as MapType, country, catalogue: isCatalogueArea(area) };
}
